
const QUOTE_CART_LOCAL_STORAGE_ID = "quote_data";
const QUOTE_PAGE_DATA = "quote_page_data";
const QUOTE_PAGE_RENDER_FLAG = "quote_page_render_flag";
const QUOTE_CART_TOTAL = "quote_cart_total";

function getQuotItemsCount() {
    const quoteData = JSON.parse(localStorage.getItem('quote_data')) || [];
    return itemCount = quoteData.reduce((total, item) => total + (item.quantity || 0), 0);
}

function quoteCartCountUpdate(){

    // const quoteData = JSON.parse(localStorage.getItem(QUOTE_CART_LOCAL_STORAGE_ID)) || [];
    // const count = quoteData.reduce((total, item) => total + item.quantity, 0);
    // // const spanQuoteCount = document.querySelector('.spanQuoteCount');

    // // spanQuoteCount.innerHTML = count;

    // const quoteCTA = document.querySelector('#quoteCTA');
    // // const cartText = document.querySelector('.c-cart-text');

    // if(quoteCTA){
    //     if(count > 0){
    //         quoteCTA.classList.remove('not-show');
    //         // cartText.classList.add('hide-when-quote');
    //     }
    //     else{
    //         quoteCTA.classList.add('not-show');
    //         // cartText.classList.remove('hide-when-quote');
    //     }
    // }

}

quoteCartCountUpdate();

function handleQuoteIconCTA(){
    const quoteIcon = document.querySelector('#quoteCTA');
    const closeBtn = document.querySelector('#quoteCTA .close-button');
    const overlay = document.querySelector('#quoteCTA .overlay-quote-cart');

    if(quoteIcon){
        quoteIcon.addEventListener('click', () => {
            const miniQuoteCart = document.querySelector('.mini-quote-cart');

            if (miniQuoteCart) {
                miniQuoteCart.setAttribute('aria-hidden', 'false');
            }
        });
    }

    if(closeBtn){
        closeBtn.addEventListener('click', function(e){
            e.stopPropagation();
            const miniQuoteCart = document.querySelector('.mini-quote-cart');
            if(miniQuoteCart){
                miniQuoteCart.setAttribute('aria-hidden', 'true');
            }
        })
    }

    if(overlay){
        overlay.addEventListener('click', function(e){
            e.stopPropagation();
            const miniQuoteCart = document.querySelector('.mini-quote-cart');
            if(miniQuoteCart){
                miniQuoteCart.setAttribute('aria-hidden', 'true');
            }
        })
    }

}

handleQuoteIconCTA();

function createQuoteHtml() {

    const quoteData = (JSON.parse(localStorage.getItem(QUOTE_CART_LOCAL_STORAGE_ID)) || []).reverse();

    if (!quoteData.length) return;

    const htmlResults = quoteData.map((quoteItem) => {
        const { variantId, productId, quantity, productData} = quoteItem;

        if (!productData || !Array.isArray(productData.variants)) return "";

        const product = productData;
        const variant = product.variants.find(v => String(v.id) === String(variantId));
        if (!variant) return "";

        const priceInt = parseInt(String(variant.price).replace('.', ''));

        let currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
        let price = Currency.formatMoney(priceInt, currencyFormat);

        return `
            <li class="flex flex-row !gap-4 !py-4 !border-b-[1.5px] !border-gray-200">
                <div class="flex flex-col items-center">
                    <div class="h-25 w-30 flex !justify-center !items-center !border !border-gray-200 !rounded pb-5">
                        <img src="${variant.featured_image?.src}" alt="${variant.featured_image?.alt || product.title}" class="!h-19" />
                    </div>
        
                    <div class="inline-flex items-center justify-center border border-gray-200 rounded overflow-hidden text-sm w-fit -mt-4 bg-white px-3">
                        <button class="!text-3xl ${quantity == 1 ? 'not-active' : ''}" onclick="changeQuantity(${productId}, ${variant.id}, '-')">-</button>
                        <input type="number"
                        min="1"
                        value="${quantity}"
                        class="!text-base !px-3 !text-center w-14 quantity-input quantity-${variantId}"
                        onchange="handleQuantityInputChange(event, ${productId}, ${variant.id})" />

                        <button class="!text-3xl" onclick="changeQuantity(${productId}, ${variant.id}, '+')">+</button>
                    </div>
        
                    <div class="!flex !items-center !justify-between !px-1 mt-3">
                        <button class="!text-xs !text-gray-500" onclick="changeQuantity(${productId}, ${variant.id}, 'remove')">Remove</button>
                    </div>
                </div>
                <div class="flex flex-col gap-2">
                    <a href="/products/${productData.handle}?variant=${variantId}" class="!text-base sm:!text-sm text-gray-800">${product.title || variant.name}</a>
                    <div class="flex flex-col gap-1">
                        <p class="!text-xs !text-gray-500">${variant.title || ''}</p>
                        <p class="text-red-600 !font-semibold !text-sm" id="product-total">
                            <span style="margin: 0 2px;">${price}</span>
                        </p>
                    </div>
                </div>
            </li>
        `;
    });

    return htmlResults.join("");
}

function handleQuantityInputChange(event, productId, variantId) {
    const value = parseInt(event.target.value, 10);
    if (isNaN(value) || value <= 0) return;
  
    changeQuantity(productId, variantId, value);
}


function changeQuantity(productId, variantId, action, onQuotePage = false) {
    const quoteData = JSON.parse(localStorage.getItem(QUOTE_CART_LOCAL_STORAGE_ID)) || [];
    const variantIdStr = String(variantId);
    let hasRemovedItem = false;
    let updatedQuoteData = [];
  
    quoteData.forEach(item => {
      if (String(item.productId) === String(productId) && String(item.variantId) === variantIdStr) {
        let quantity = item.quantity || 1;
  
        if (action === '+') {
          quantity += 1;
        } else if (action === '-') {
          quantity -= 1;
        } else if (action === 'remove') {
          hasRemovedItem = true;
          return;
        } else if (typeof action === 'number' && action > 0) {
          quantity = action;
        }
  
        if (quantity > 0) {
          updatedQuoteData.push({ ...item, quantity });
        } else {
          hasRemovedItem = true;
        }
      } else {
        updatedQuoteData.push(item);
      }
    });
  
    localStorage.setItem(QUOTE_CART_LOCAL_STORAGE_ID, JSON.stringify(updatedQuoteData));
  
    updateQuanityValue(variantId);
    quoteCartCountUpdate();
    calculateQuoteCartTotal();
  
    if (hasRemovedItem) {
        if (!onQuotePage) showQuote(true);
        populateProductsOnQuotePages();
    }
  }
  
function updateQuanityValue(variantId) {

    variantId = String(variantId);

    const quoteData = JSON.parse(localStorage.getItem(QUOTE_CART_LOCAL_STORAGE_ID)) || [];
    const currentItem = quoteData.find((item) => String(item.variantId) === variantId);

    const quantity = currentItem?.quantity || 0;

    const spans = document.querySelectorAll(`.quantity-${variantId}`);

    spans.forEach((span) => {
        const li = span.closest("li");
        const minusBtn = li?.querySelector(".minus-quantity");
      
        if (quantity > 1) {
          if (span.tagName === "INPUT") {
            span.value = quantity;
          } else {
            span.innerText = quantity;
          }
          minusBtn?.classList.remove("not-active");
      
        } else if (quantity === 1) {
          if (span.tagName === "INPUT") {
            span.value = quantity;
          } else {
            span.innerText = quantity;
          }
          minusBtn?.classList.add("not-active");
      
        } else {
          li?.remove();
          localStorage.setItem(QUOTE_PAGE_RENDER_FLAG, true);
        }
      });
      

    window.dispatchEvent(new CustomEvent('quote:refresh'));

    // Sync quote page DOM
    const quotePageSpan = document.querySelector(
        `#requestQuoteItemsOnPage .quantity-${variantId}`
    );
    const quotePageLi = quotePageSpan?.closest("li");

    if (quotePageSpan) {
        if (quantity > 0) {
        quotePageSpan.innerText = quantity;
        } else {
        quotePageLi?.remove();
        }
    }
}
    
function populateProductsInQuoteCart(trigger, containerId="#quoteContent") {

    // let htmlcontent = createQuoteHtml(1);

    // const quoteContentContainer = document.querySelector(containerId);

    // if (quoteContentContainer) quoteContentContainer.innerHTML = htmlcontent;

    quoteCartCountUpdate();
    calculateQuoteCartTotal();
    window.dispatchEvent(new CustomEvent('quote:refresh'));

    if (trigger) {
        if (window.innerWidth < 1024) {
            window.scrollTo({
                top: 0,
                behavior: 'instant'
              });              
            openQuotePage();
          } else {
            toggleSidebar('quote');
          }        
    }

    document.dispatchEvent(new CustomEvent('theme:loading:end'));

}

populateProductsInQuoteCart();


function toggleQuoteCart() {

    const miniQuoteCart = document.querySelector('.mini-quote-cart');

    if (miniQuoteCart.classList.contains('hidden')) {
        miniQuoteCart.classList.remove('hidden', 'animate-fadeout');
        miniQuoteCart.classList.add('animate-fadein');
    } else {
        miniQuoteCart.classList.remove('animate-fadein');
        miniQuoteCart.classList.add('animate-fadeout');
        setTimeout(() => { miniQuoteCart.classList.add('hidden') }, 200);
      }
    
    document.dispatchEvent(new CustomEvent('theme:loading:end'));

}

function handleSubmitQuoteButton() {
    const submitQuoteButtons = document.querySelectorAll('.submit_quote_button');
    const html = document.querySelector('html');
    console.log(submitQuoteButtons);
    let currentLanguage = html.getAttribute('lang') !== 'en' ? html.getAttribute('lang') : '';
    
    submitQuoteButtons.forEach(button => {
      const dataRedirectUrl = button.getAttribute('data-redirect-url');
      const dataNewAddressURL = button.getAttribute('data-shopify-logged-url');
      const customer = button.getAttribute('data-customer');
  
      button.addEventListener('click', function (e) {
        e.preventDefault();
  
        const redirectPath = customer === 'true' ? dataNewAddressURL : dataRedirectUrl;
        const fullPath = currentLanguage ? `/${currentLanguage}${redirectPath}` : redirectPath;
  
        window.location.href = fullPath;
      });
    });
}
  
handleSubmitQuoteButton();


async function populateProductsOnQuotePages() {
    const startTime = Date.now(); 
    let reRender = false;
    const requestQuoteItemsOnPage = document.querySelector('#requestQuoteItemsOnPage');
    const _quoteData = JSON.parse(localStorage.getItem(QUOTE_CART_LOCAL_STORAGE_ID)) || [];
    const quotePageHTMLLocalData = JSON.parse(localStorage.getItem(QUOTE_PAGE_DATA));
    const reRenderFlagForQuotePage = localStorage.getItem(QUOTE_PAGE_RENDER_FLAG);

    // console.log("QUOTE_PAGE_RENDER_FLAG", reRenderFlagForQuotePage);

    const quoteData = _quoteData.reverse();
    let htmlDataToRender = "";

    const currentLanguage = Shopify.locale;
    const currentCurrency = Shopify?.currency?.active;

    // if(!quotePageHTMLLocalData){
    //     reRender = true
    // }
    // else if(quotePageHTMLLocalData.currentLanguage != Shopify?.locale || quotePageHTMLLocalData.currentCurrency != Shopify?.currency?.active){
    //     reRender = true;
    // }

    // if(reRenderFlagForQuotePage == "true"){
    //     reRender = true;
    // }

    reRender = true;

    if(reRender){
        if (requestQuoteItemsOnPage && quoteData.length > 0) {

            const fetchPromises = quoteData.map(async (quoteItem) => {
                const variantId = String(quoteItem.variantId);
                const productData = quoteItem.productData;
                const quantity = quoteItem.quantity;
    
                const fetchURLWithoutJson =
                    currentLanguage !== "en"
                        ? `https://www.monitors.com/${currentLanguage}/products/${productData.handle}`
                        : `https://www.monitors.com/products/${productData.handle}`;
    
                try {
                    const responseData = await fetch(fetchURLWithoutJson, { redirect: "follow" });
    
                    if (responseData.ok) {
                        const finalURL = `${responseData.url}?variant=${variantId}&view=quote-page-item`;
                        const response = await fetch(finalURL);
    
                        if (response.ok) {
                            const htmlData = await response.text();
                            return htmlData; 
                        } else {
                            console.error(`Failed to fetch product data for handle: ${productData.handle}`);
                        }
                    }
                } catch (error) {
                    console.error(`Error fetching product data for handle: ${productData.handle}`, error);
                }
    
                return ""; 
            });
    
            
            const htmlResults = await Promise.all(fetchPromises);

            // console.log("testing ====>", htmlResults);
    
            htmlDataToRender = htmlResults.join("");
                
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlDataToRender, 'text/html');
            
            doc.querySelectorAll('.line-item').forEach(lineItem => {
              const proId = lineItem.getAttribute('data-pro-id');
              const varId = lineItem.getAttribute('data-var-id');
            
              const item = quoteData.find(i => i.variantId === varId);
              const quantity = item ? item.quantity : 1;

              const newHtml = `
                <div class="inline-flex items-center justify-center border border-gray-200 rounded overflow-hidden text-sm w-fit -mt-4 bg-white px-3">
                  <button class="!text-3xl" onclick="changeQuantity(${proId}, ${varId}, '-')">-</button>
                  <input type="number"
                    min="1"
                    value="${quantity}"
                    class="!text-base !px-3 !text-center w-14 quantity-input quantity-${varId}"
                    onchange="handleQuantityInputChange(event, ${proId}, ${varId})" />
                  <button class="!text-3xl" onclick="changeQuantity(${proId}, ${varId}, '+')">+</button>
                </div>
              `;
            
              const quantityContainer = lineItem.querySelector('.quote-page-quantity-container');
              if (quantityContainer) {
                quantityContainer.innerHTML = newHtml;
              }
            });
            
            htmlDataToRender = doc.body.innerHTML;
            
            htmlDataToRender = htmlDataToRender.replaceAll(
                /removeQuoteItemFromCart\((\d+),\s*(\d+)\)/g,
                (match, p1, p2) => `changeQuantity(${p1}, ${p2}, 'remove', true)`
              );
              

            // htmlDataToRender = htmlDataToRender.replaceAll('quantityPlusQuoteCart', 'changeQuantity');

            requestQuoteItemsOnPage.innerHTML = htmlDataToRender;

            const dataToStoreInLocalStorage = {
                currentLanguage: currentLanguage,
                currentCurrency: currentCurrency,
                htmlDataToRender: htmlDataToRender
            };
    
            localStorage.setItem(QUOTE_PAGE_DATA, JSON.stringify(dataToStoreInLocalStorage));
            localStorage.setItem(QUOTE_PAGE_RENDER_FLAG, false);
        }
        else{
            if(requestQuoteItemsOnPage){
                requestQuoteItemsOnPage.innerHTML = "";
            }
        }
    }
    else{
        if(requestQuoteItemsOnPage){
            const htmlDataToRender = quotePageHTMLLocalData.htmlDataToRender;
            requestQuoteItemsOnPage.innerHTML = htmlDataToRender;
            // console.log("Data is rendering from local storage");
        }
    }
    manageQuantityRenderOnQuotePages();
    const endTime = Date.now();
    // console.log("Execution time to populate products:", `${endTime - startTime}ms`);
}

function openQuoteCart() {
    setTimeout(function () {
        const trigger = document.querySelector('#quoteCTA');
        console.log(trigger);
        if (trigger) {
            trigger.click();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, 1000);
    
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
}

populateProductsOnQuotePages();


function manageQuantityRenderOnQuotePages() {
    const quoteData = JSON.parse(localStorage.getItem(QUOTE_CART_LOCAL_STORAGE_ID)) || [];
    const requestQuoteItemsOnPage = document.querySelector('#requestQuoteItemsOnPage');

    if (requestQuoteItemsOnPage && quoteData.length > 0) {
        const quoteItemsHtml = requestQuoteItemsOnPage.querySelectorAll('.quote-page-item');

        if (quoteItemsHtml.length > 0) {
            quoteItemsHtml.forEach((quoteItem) => {
                const variantId = quoteItem.getAttribute('data-variant-id');

                if (variantId) {
                    const matchingQuoteData = quoteData.find(
                        (item) => String(item.variantId) === variantId
                    );

                    if (matchingQuoteData) {
                        const quantityInput = quoteItem.querySelector('.quote-page-quantity-input');
                        
                        if (quantityInput) {
                            quantityInput.value = matchingQuoteData.quantity;
                        }
                    }
                }
            });
        }
    }
}

function clearQuoteLocalStorage() {
    const keysToRemove = [
        "quote_data",  
        "quote_page_data",  
        "quote_page_render_flag"
    ];
    keysToRemove.forEach(key => {
        if (localStorage.getItem(key) !== null) {
            localStorage.removeItem(key);
        }
    });
    quoteCartCountUpdate();
    // console.log("All specified localStorage items have been removed.");
}


function calculateQuoteCartTotal() {
    const quoteData = JSON.parse(localStorage.getItem(QUOTE_CART_LOCAL_STORAGE_ID)) || [];

    if (quoteData.length > 0) {
        let totalPrice = 0;

        const quoteContent = document.querySelector('#quoteContent');

        if (quoteContent) {
            const quoteItems = quoteContent.querySelectorAll('.quote-item');

            quoteItems.forEach((item) => {
                let variantPrice = item.getAttribute('data-variant-price') || "0";
                variantPrice = parseInt(variantPrice.replace('.', ''));
                const quantityInput = item.querySelector('.quantity-input');
                const quantity = parseInt(quantityInput?.value || 0);
                totalPrice += variantPrice * quantity;
            });
        }

        let totalPriceCurrencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
        let totalPriceFormattedPrice = Currency.formatMoney(totalPrice, totalPriceCurrencyFormat);

        //console.log(`Total Price of Variants: ${totalPriceFormattedPrice}`);

        const quoteCartTotalContainer = document.querySelector('.quote-cart-total');

        if(quoteCartTotalContainer){
            quoteCartTotalContainer.setAttribute('data-subtotal', totalPriceFormattedPrice);
        }
    }
}
